export function initPlatformWhy() {
  const section = document.querySelector('.section_platform-why');
  if (!section) return;

  const panes = section.querySelector('.platform-why_tabs-panes');
  const tabMenu = section.querySelector('.platform-why_tabs-menu');
  const tabLinks = Array.from(section.querySelectorAll('.platform-why_tab-link'));
  if (!panes || !tabMenu || tabLinks.length === 0) return;

  const getCurrentIndex = () => tabLinks.findIndex((link) => link.classList.contains('w--current'));

  const scrollTabIntoView = (link) => {
    const menuRect = tabMenu.getBoundingClientRect();
    const linkRect = link.getBoundingClientRect();
    // Center the link inside the tab menu
    const offset = linkRect.left - menuRect.left - (menuRect.width - linkRect.width) / 2;
    tabMenu.scrollBy({ left: offset, behavior: 'smooth' });
  };

  const goToTab = (index) => {
    const clamped = Math.max(0, Math.min(tabLinks.length - 1, index));
    const link = tabLinks[clamped];
    link.click();
    scrollTabIntoView(link);
  };

  let gestureHandled = false;

  Observer.create({
    target: panes,
    type: 'touch,pointer',
    tolerance: 40,
    preventDefault: false,
    onPress: () => {
      gestureHandled = false;
    },
    onLeft: () => {
      if (gestureHandled) return;
      gestureHandled = true;
      goToTab(getCurrentIndex() + 1);
    },
    onRight: () => {
      if (gestureHandled) return;
      gestureHandled = true;
      goToTab(getCurrentIndex() - 1);
    },
  });
}
